import React from "react";

/**
 * v77.99.153 (iter 131.footer-legal) — Legal / company-registration
 * strip. Rendered inside every public footer as a distinct row so
 * the visual hierarchy stays: brand · tagline · links · legal.
 *
 * The three lines are prescribed copy — do not change without
 * matching the Companies Registration Office record.
 */
export default function LegalFooterInfo({ testid = "footer-legal-info" }) {
  return (
    <div
      className="border-t border-[#E5EBEC] dark:border-[#1F2A2D]"
      data-testid={testid}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-4 text-[11px] leading-relaxed text-[#6F828A] dark:text-[#7A8A91] text-center space-y-0.5">
        <p>
          © 2026 CoParent Console | CoParent Console is a registered business
          name of Avenza Group Ltd.
        </p>
        <p>Avenza Group Ltd is registered in Ireland.</p>
        <p>
          Company No. 715992. Registered Office: 77 Camden Street Lower, Saint
          Kevin&#39;s, Dublin, D02 XE80.
        </p>
      </div>
    </div>
  );
}
